import React from 'react';
import ListOfNames from './components/ListOfNames';

function App() {
  return (
    <div className='App'>
      <ListOfNames />
    </div>
  );
}

export default App;
